import Vue from 'vue'
import { Button, Popup, Form, Field, Icon, Divider, Loading, Picker, Checkbox, Lazyload, Toast, Tag, CellGroup, Search, Dialog, ActionSheet, CheckboxGroup,Radio,RadioGroup ,Overlay} from 'vant'
import vClickOutside from 'v-click-outside'
import suggestion from '@/components/suggestion'
import VerifyCode from '@/components/verify-code'
import CheckAgree from '@/components/check-agree'
import HiddenModules from '@/directives/hiddenModules'

Vue.use(Lazyload)
Vue.use(vClickOutside)
Vue.use(HiddenModules)

Vue.component(suggestion.name, suggestion)
Vue.component(VerifyCode.name, VerifyCode)
Vue.component(CheckAgree.name, CheckAgree)
;[Dialog, Button, Popup, Form, Field, Icon, Divider, Loading, Picker, Checkbox, CheckboxGroup, Toast, Tag, CellGroup, Search, ActionSheet,Radio,RadioGroup,Overlay].forEach((Comp) => Vue.use(Comp))
